import { useCallback } from 'react'
import { Assignment } from '../params'
import { LendersPosition } from 'app/models/lenders-position-params'
import { UseListStateHandlers } from '@mantine/hooks'

type UseAdjustLenderPositionEditProps = {
  updatedLendersPositions: LendersPosition[]
  updatedLendersPositionsHandler: UseListStateHandlers<LendersPosition>
  assignmentsList: Assignment[]
  selectedRow: number | null
  createNewLenderPosition: (trade: any, id: string) => LendersPosition
}

const useAdjustLenderPositionEdit = ({
  updatedLendersPositions,
  updatedLendersPositionsHandler,
  assignmentsList,
  selectedRow,
  createNewLenderPosition,
}: UseAdjustLenderPositionEditProps) => {
  const adjustLenderPositionEdit = useCallback(
    (assignment: Assignment) => {
      const existsInLendersPosition = updatedLendersPositions.some(
        lender => lender.lender.id === assignment.to
      )

      const newLendersPositions = updatedLendersPositions.filter(lender => {
        if (lender.lender.id === assignmentsList[selectedRow ?? 0].to) {
          lender.amount = (
            Number(lender.amount) -
            Number(assignmentsList[selectedRow ?? 0].amount)
          ).toString()
        }
        if (lender.lender.id === assignmentsList[selectedRow ?? 0].from) {
          lender.amount = (
            Number(lender.amount) +
            Number(assignmentsList[selectedRow ?? 0].amount)
          ).toString()
        }

        if (lender.lender.id === assignment.to) {
          lender.amount = (
            Number(lender.amount) + Number(assignment.amount)
          ).toString()
        }
        if (lender.lender.id === assignment.from) {
          lender.amount = (
            Number(lender.amount) - Number(assignment.amount)
          ).toString()
        }
        return Number(lender.amount) >= 0 // Filter out lenders with amount <= 0
      })

      updatedLendersPositionsHandler.setState(newLendersPositions)

      if (existsInLendersPosition === false) {
        const newLender = createNewLenderPosition(assignment, assignment.to)
        updatedLendersPositions.push(newLender)
        updatedLendersPositionsHandler.setState(updatedLendersPositions)
      }
    },
    [
      updatedLendersPositions,
      updatedLendersPositionsHandler,
      assignmentsList,
      selectedRow,
      createNewLenderPosition,
    ]
  )

  return adjustLenderPositionEdit
}

export default useAdjustLenderPositionEdit
